// Actions
export const FETCH_DECLINE_REASONS = 'companyExperience/views/hiringAnalytics/FETCH_DECLINE_REASONS'
export const FETCH_DECLINE_REASONS_SUCCESS = 'companyExperience/hiringAnalytics/FETCH_DECLINE_REASONS_SUCCESS'
export const FETCH_DECLINE_REASONS_ERROR = 'companyExperience/hiringAnalytics/FETCH_DECLINE_REASONS_ERROR'

export const FETCH_STATIC_DECLINE_REASONS = 'companyExperience/views/hiringAnalytics/FETCH_STATIC_DECLINE_REASONS'
export const FETCH_STATIC_DECLINE_REASONS_SUCCESS = 'companyExperience/hiringAnalytics/FETCH_STATIC_DECLINE_REASONS_SUCCESS'
export const FETCH_STATIC_DECLINE_REASONS_ERROR = 'companyExperience/hiringAnalytics/FETCH_STATIC_DECLINE_REASONS_ERROR'

export const FETCH_INTERVIEW_REQUESTS = 'companyExperience/views/hiringAnalytics/FETCH_INTERVIEW_REQUESTS'
export const FETCH_INTERVIEW_REQUESTS_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_INTERVIEW_REQUESTS_SUCCESS'
export const FETCH_INTERVIEW_REQUESTS_ERROR = 'companyExperience/hiringAnalytics/FETCH_INTERVIEW_REQUESTS_ERROR'

export const FETCH_NEW_CANDIDATES = 'companyExperience/views/hiringAnalytics/FETCH_NEW_CANDIDATES'
export const FETCH_NEW_CANDIDATES_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_NEW_CANDIDATES_SUCCESS'
export const FETCH_NEW_CANDIDATES_ERROR = 'companyExperience/views/hiringAnalytics/FETCH_NEW_CANDIDATES_ERROR'

export const FETCH_POSITIONS = 'companyExperience/views/hiringAnalytics/FETCH_POSITIONS'
export const FETCH_POSITIONS_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_POSITIONS_SUCCESS'
export const FETCH_POSITIONS_ERROR = 'companyExperience/views/hiringAnalytics/FETCH_POSITIONS_ERROR'

export const SORT_POSITIONS = 'companyExperience/views/hiringAnalytics/SORT_POSITIONS'

export const FETCH_PROFILE_VIEWS = 'companyExperience/views/hiringAnalytics/FETCH_PROFILE_VIEWS'
export const FETCH_PROFILE_VIEWS_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_PROFILE_VIEWS_SUCCESS'
export const FETCH_PROFILE_VIEWS_ERROR = 'companyExperience/views/hiringAnalytics/FETCH_PROFILE_VIEWS_ERROR'

export const FETCH_QUARTER_RATES = 'companyExperience/views/hiringAnalytics/FETCH_QUARTER_RATES'
export const FETCH_QUARTER_RATES_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_QUARTER_RATES_SUCCESS'
export const FETCH_QUARTER_RATES_ERROR = 'companyExperience/views/hiringAnalytics/FETCH_QUARTER_RATES_ERROR'

export const FETCH_RATES = 'companyExperience/views/hiringAnalytics/FETCH_RATES'
export const FETCH_RATES_SUCCESS = 'companyExperience/views/hiringAnalytics/FETCH_RATES_SUCCESS'
export const FETCH_RATES_ERROR = 'companyExperience/views/hiringAnalytics/FETCH_RATES_ERROR'

// Action creators
export const fetchDeclineReasons = () => ({
  type: FETCH_DECLINE_REASONS,
  payload: {
    fetchingDeclineReasons: true,
    fetchDeclineReasonsError: null,
  },
})

export const fetchDeclineReasonsSuccess = ({ result }) => ({
  type: FETCH_DECLINE_REASONS_SUCCESS,
  payload: {
    fetchingDeclineReasons: false,
    lastUpdatedDeclineReasons: Date.now(),
    declineReasons: result,
  },
})

export const fetchDeclineReasonsError = errorMessage => ({
  type: FETCH_DECLINE_REASONS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchStaticDeclineReasons = () => ({
  type: FETCH_STATIC_DECLINE_REASONS,
  payload: {
    fetchingStaticDeclineReasons: true,
    fetchStaticDeclineReasonsError: null,
  },
})

export const fetchStaticDeclineReasonsSuccess = ({ result }) => ({
  type: FETCH_STATIC_DECLINE_REASONS_SUCCESS,
  payload: {
    fetchingStaticDeclineReasons: false,
    lastUpdatedStaticDeclineReasons: Date.now(),
    staticDeclineReasons: result,
  },
})

export const fetchStaticDeclineReasonsError = errorMessage => ({
  type: FETCH_STATIC_DECLINE_REASONS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchInterviewRequests = () => ({
  type: FETCH_INTERVIEW_REQUESTS,
  payload: {
    fetchingInterviewRequests: true,
    fetchInterviewRequestsError: null,
  },
})

export const fetchInterviewRequestsSuccess = ({ result }) => ({
  type: FETCH_INTERVIEW_REQUESTS_SUCCESS,
  payload: {
    fetchingInterviewRequests: false,
    lastUpdatedInterviewRequests: Date.now(),
    interviewRequests: result,
  },
})

export const fetchInterviewRequestsError = errorMessage => ({
  type: FETCH_INTERVIEW_REQUESTS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchNewCandidates = () => ({
  type: FETCH_NEW_CANDIDATES,
  payload: {
    fetchingNewCandidates: true,
    fetchNewCandidatesError: null,
  },
})

export const fetchNewCandidatesSuccess = ({ result }) => ({
  type: FETCH_NEW_CANDIDATES_SUCCESS,
  payload: {
    fetchingNewCandidates: false,
    lastUpdatedNewCandidates: Date.now(),
    newCandidates: result,
  },
})

export const fetchNewCandidatesError = errorMessage => ({
  type: FETCH_NEW_CANDIDATES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchPositions = () => ({
  type: FETCH_POSITIONS,
  payload: {
    fetchingPositions: true,
    fetchPositionsError: null,
  },
})

export const fetchPositionsSuccess = ({ result }) => ({
  type: FETCH_POSITIONS_SUCCESS,
  payload: {
    fetchingPositions: false,
    lastUpdatedPositions: Date.now(),
    positions: result,
  },
})

export const fetchPositionsError = errorMessage => ({
  type: FETCH_POSITIONS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const sortPositions = sortPositions => ({
  type: SORT_POSITIONS,
  payload: { sortPositions },
})

export const fetchProfileViews = () => ({
  type: FETCH_PROFILE_VIEWS,
  payload: {
    fetchingProfileViews: true,
    fetchProfileViewsError: null,
  },
})

export const fetchProfileViewsSuccess = ({ result }) => ({
  type: FETCH_PROFILE_VIEWS_SUCCESS,
  payload: {
    fetchingProfileViews: false,
    lastUpdatedProfileViews: Date.now(),
    profileViews: result,
  },
})

export const fetchProfileViewsError = errorMessage => ({
  type: FETCH_PROFILE_VIEWS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchQuarterRates = () => ({
  type: FETCH_QUARTER_RATES,
  payload: {
    fetchingQuarterRates: true,
    fetchQuarterRatesError: null,
  },
})

export const fetchQuarterRatesSuccess = ({ result }) => ({
  type: FETCH_QUARTER_RATES_SUCCESS,
  payload: {
    fetchingQuarterRates: false,
    lastUpdatedQuarterRates: Date.now(),
    quarterRates: result,
  },
})

export const fetchQuarterRatesError = errorMessage => ({
  type: FETCH_QUARTER_RATES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchRates = () => ({
  type: FETCH_RATES,
  payload: {
    fetchingRates: true,
    fetchRatesError: null,
  },
})

export const fetchRatesSuccess = ({ result }) => ({
  type: FETCH_RATES_SUCCESS,
  payload: {
    fetchingRates: false,
    lastUpdatedRates: Date.now(),
    rates: result,
  },
})

export const fetchRatesError = errorMessage => ({
  type: FETCH_RATES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// Reducers
const defaultView = {
  fetchingDeclineReasons: false,
  fetchDeclineReasonsError: null,
  lastUpdatedDeclineReasons: null,
  declineReasons: [],

  fetchingStaticDeclineReasons: false,
  fetchStaticDeclineReasonsError: null,
  lastUpdatedStaticDeclineReasons: null,
  staticDeclineReasons: [],

  fetchingInterviewRequests: false,
  fetchInterviewRequestsError: null,
  lastUpdatedInterviewRequests: null,
  interviewRequests: [],

  fetchingNewCandidates: false,
  fetchNewCandidatesError: null,
  lastUpdatedNewCandidates: null,
  newCandidates: {},

  fetchingPositions: false,
  fetchPositionsError: null,
  lastUpdatedPositions: null,
  positions: [],
  sortPositions: {},

  fetchingProfileViews: false,
  fetchProfileViewsError: null,
  lastUpdatedProfileViews: null,
  profileViews: [],

  fetchingQuarterRates: false,
  fetchQuarterRatesError: null,
  lastUpdatedQuarterRates: null,
  quarterRates: {},

  fetchingRates: false,
  fetchRatesError: null,
  lastUpdatedRates: null,
  rates: {},
}

const view = (state = defaultView, { type, payload }) => {
  switch (type) {
    case FETCH_DECLINE_REASONS:
    case FETCH_DECLINE_REASONS_SUCCESS:
    case FETCH_STATIC_DECLINE_REASONS_SUCCESS:
    case FETCH_INTERVIEW_REQUESTS:
    case FETCH_INTERVIEW_REQUESTS_SUCCESS:
    case FETCH_NEW_CANDIDATES:
    case FETCH_NEW_CANDIDATES_SUCCESS:
    case FETCH_POSITIONS:
    case FETCH_POSITIONS_SUCCESS:
    case SORT_POSITIONS:
    case FETCH_PROFILE_VIEWS:
    case FETCH_PROFILE_VIEWS_SUCCESS:
    case FETCH_QUARTER_RATES:
    case FETCH_QUARTER_RATES_SUCCESS:
    case FETCH_RATES:
    case FETCH_RATES_SUCCESS:
      return { ...state, ...payload }

    case FETCH_DECLINE_REASONS_ERROR:
      return { ...state, fetchingDeclineReasons: false, fetchDeclineReasonsError: payload }

    case FETCH_STATIC_DECLINE_REASONS_ERROR:
      return { ...state, fetchingStaticDeclineReasons: false, fetchStaticDeclineReasonsError: payload }

    case FETCH_INTERVIEW_REQUESTS_ERROR:
      return { ...state, fetchingInterviewRequests: false, fetchInterviewRequestsError: payload }

    case FETCH_NEW_CANDIDATES_ERROR:
      return { ...state, fetchingNewCandidates: false, fetchNewCandidatesError: payload }

    case FETCH_POSITIONS_ERROR:
      return { ...state, fetchingPositions: false, fetchPositionsError: payload }

    case FETCH_PROFILE_VIEWS_ERROR:
      return { ...state, fetchingProfileViews: false, fetchProfileViewsError: payload }

    case FETCH_QUARTER_RATES_ERROR:
      return { ...state, fetchingQuarterRates: false, fetchQuarterRatesError: payload }

    case FETCH_RATES_ERROR:
      return { ...state, fetchingRates: false, fetchRatesError: payload }

    default:
      return state
  }
}

export default view

export const getHiringAnalyticsView = state => state.views.hiringAnalytics || defaultView
